import { useEffect } from "react";
import Reviews from "../components/Reviews";

export default function ReviewsPage() {
  useEffect(() => {
    // Unlisted page — not linked in navigation, and excluded from search
    // engine indexing so it's only reachable via a direct link.
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return <Reviews />;
}